import React from 'react';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import About from 'pages/about';
import ArchitectureDesign from 'pages/architectureDesign';
import Careers from 'pages/careers';
import CareerDetails from 'pages/careerDetails';
import Contact from 'pages/contact';
import Events from 'pages/events';
import EventDetails from 'pages/eventDetails';
import OurHomes from 'pages/homes';
import HomePage from 'pages/landing';
import NotFound from 'pages/notFound';
import Privacy from 'pages/privacy';
import ProjectDetails from 'pages/projectDetails';
import ProductDetails from 'pages/productDetails';
import Rentals from 'pages/rentals';
import RentalDetails from 'pages/rentalDetails';
import Resorts from 'pages/resorts';
import OurRestaurants from 'pages/restaurants';
import DiningDetails from 'pages/restaurantDetails';
import CraftBeerPage from 'pages/craftBeerBrewery';
import Stores from 'pages/stores';
import Terms from 'pages/terms';
import Workspaces from 'pages/workspaces';
import { NavigationUtil } from 'utils/NavigationUtil';
import CampaignPage from 'pages/campaign';
import PropertyManagement from 'pages/propertyManagement';
import LoyaltyProgram from 'pages/loyaltyProgram';
import ThinkDesign from 'pages/thinkDesign';
import WorkspaceDetails from 'pages/workspaceDetails';
import ThankYou from 'pages/thankYou';
import CompletedProjectRentals from 'pages/completedProjectRentals';
import PaymentConfirmation from 'pages/paymentConfirmation';
import PaymentCancellation from 'pages/paymentCancellation';
import PastEventsPage from 'pages/pastEvents';
import landCraft from 'pages/landCraft';
import landCraftDetails from 'pages/landCraftDetails';
import workspaceProductDetails from 'pages/workspaceProductDetails';
import TermsAndConditions from 'pages/terms&conditions';

export const RouteNames = {
  landing: '/',
  homes: '/homes',
  projectDetails: '/:projectSlug',
  productDetails: '/homes/:productSlug',
  restaurants: '/restaurants',
  restaurantDetails: '/restaurants/:restaurantSlug/:outletSlug',
  careers: '/careers',
  careerDetails: '/careers/:careerSlug',
  about: '/about',
  store: '/store',
  rentals: '/rentals',
  thankYou: '/thank-you',
  rentalDetails: '/rentals/:projectSlug/:productSlug/:rentalSlug',
  workcations: '/workcations',
  workcationsDetails: '/workcations/:workspaceSlug',
  workcationsProductDetails: '/workcations/product/:productSlug',
  resorts: '/resorts',
  musicEvents: '/music-and-events',
  pastMusicEvents: '/past-music-and-events',
  eventDetails: '/music-and-events/:eventSlug',
  architectureDesign: '/architecture-and-design',
  craftBeerBrewery: '/craftbeer-and-brewery',
  contact: '/contact',
  //TODO : add 'blog' route name.
  blog: '',
  terms: '/disclaimer',
  privacy: '/privacy-policy',
  notFound: '/not-found',
  campaign: '/campaign/:campaignSlug',
  property: '/property-management',
  loyaltyProgram: '/loyalty-program',
  thinkDesign: '/think-design',
  completedProjectRentals: '/rentals/:rentalSlug',
  paymentConfirmation: '/confirmation',
  paymentCancellation: '/cancelled',
  landCraft: '/Landcraft',
  landCraftDetails: '/Landcraft/:projectSlug',
  conditions: '/terms-and-conditions',
};

export default function RouteComponent() {
  const checkForUrl = props => {
    let isPathExist = false;
    const path = NavigationUtil.getVerticalKeyForLocation(props.location);
    for (let key in RouteNames) {
      if (key !== 'projectDetails' && key !== 'landing') {
        let routePath = RouteNames[key].split('/', 2);
        if (path !== routePath[1]) {
          isPathExist = false;
        } else {
          isPathExist = true;
          return <NotFound />;
        }
      }
    }
    if (!isPathExist) {
      return <ProjectDetails {...props} />;
    }
  };

  return (
    <Router>
      <Switch>
        <Route exact path={RouteNames.landing} component={HomePage} />
        <Route exact path={RouteNames.campaign} component={CampaignPage} />
        <Route exact path={RouteNames.homes} component={OurHomes} />
        <Route
          exact
          path={RouteNames.productDetails}
          component={ProductDetails}
        />
        <Route exact path={RouteNames.restaurants} component={OurRestaurants} />
        <Route
          exact
          path={RouteNames.restaurantDetails}
          component={DiningDetails}
        />
        <Route exact path={RouteNames.careers} component={Careers} />
        <Route
          exact
          path={RouteNames.careerDetails}
          component={CareerDetails}
        />
        <Route exact path={RouteNames.about} component={About} />
        <Route exact path={RouteNames.rentals} component={Rentals} />
        <Route
          exact
          path={RouteNames.rentalDetails}
          component={RentalDetails}
        />
        <Route exact path={RouteNames.musicEvents} component={Events} />
        <Route exact path={RouteNames.eventDetails} component={EventDetails} />
        <Route exact path={RouteNames.pastMusicEvents} component={PastEventsPage} />
        <Route
          exact
          path={RouteNames.architectureDesign}
          component={ArchitectureDesign}
        />
        <Route
          exact
          path={RouteNames.craftBeerBrewery}
          component={CraftBeerPage}
        />
        <Route exact path={RouteNames.contact} component={Contact} />
        <Route exact path={RouteNames.terms} component={Terms} />
        <Route exact path={RouteNames.privacy} component={Privacy} />
        <Route
          exact
          path={RouteNames.conditions}
          component={TermsAndConditions}
        />
        <Route
          exact
          path={RouteNames.property}
          component={PropertyManagement}
        />
        <Route
          exact
          path={RouteNames.loyaltyProgram}
          component={LoyaltyProgram}
        />
        <Route exact path={RouteNames.thinkDesign} component={ThinkDesign} />
        <Route exact path={RouteNames.resorts} component={Resorts} />
        <Route exact path={RouteNames.store} component={Stores} />
        <Route exact path={RouteNames.workcations} component={Workspaces} />
        <Route exact path={RouteNames.thankYou} component={ThankYou} />
        <Route exact path={RouteNames.landCraft} component={landCraft} />
        <Route
          exact
          path={RouteNames.landCraftDetails}
          component={landCraftDetails}
        />
        <Redirect exact from={'/Land-Craft'} to={RouteNames.landCraft} />
        <Redirect
          exact
          from={'/Land-Craft/:projectSlug'}
          to={RouteNames.landCraftDetails}
        />
        <Route
          exact
          path={RouteNames.paymentConfirmation}
          component={PaymentConfirmation}
        />
        <Route
          exact
          path={RouteNames.paymentCancellation}
          component={PaymentCancellation}
        />
        <Route
          exact
          path={RouteNames.workcationsDetails}
          component={WorkspaceDetails}
        />
        <Route
          exact
          path={RouteNames.workcationsProductDetails}
          component={workspaceProductDetails}
        />
        <Route
          exact
          path={RouteNames.projectDetails}
          render={props => checkForUrl(props)}
        />
        <Route
          exact
          path={RouteNames.completedProjectRentals}
          component={CompletedProjectRentals}
        />
        <Route exact path={RouteNames.notFound} component={NotFound} />
        <Redirect to={RouteNames.notFound} />
      </Switch>
    </Router>
  );
}
